import React, {useState} from "react";
import {Form} from "react-bootstrap";
import DatePicker from 'react-date-picker'

export default function DateRangeSlider(props){
    const DAYS_STEP = 7;
    const date = new Date(props.timestamp);
    const dateUntil = new Date(date.getTime());
    dateUntil.setDate(date.getDate()+ DAYS_STEP*2-1)
    const day = date.getDate();
    const dayUntil = dateUntil.getDate();
    const month = date.getMonth()+1;
    const monthUntil = dateUntil.getMonth()+1

    const [value, setValue] = useState(50)

    const scrollControll = (event)=>{
        const step = event.target.value - value;
        setValue(event.target.value)
        let newDate = new Date(date.getTime())
        newDate.setDate(newDate.getDate() + step*DAYS_STEP);
        props.onChangeDate(newDate);
    }

    const onChange = (newDate)=>{
        newDate.setHours(12);
        props.onChangeDate(newDate);
    }

    return(
        <div className={"text-center mt-5 position-relative"}>
            <div style={{position:"absolute", left:"50%", top:"-2rem", zIndex:99, display:"inline-block", transform:"translatex(-50%)"}}>
                <DatePicker onChange={onChange}  showLeadingZeros={true} clearIcon={null} value={date} />
            </div>
            <Form.Range value={value} className={"verticalRange"} onChange={scrollControll} />
            <div>{day} {getMonthName(month)} - {dayUntil} {getMonthName(monthUntil)}</div>
        </div>
    )
}

function getMonthName(pos){
    switch (pos){
        case 1:
            return "Styczeń"
        case 2:
            return "Luty"
        case 3:
            return "Marzec"
        case 4:
            return "Kwiecień"
        case 5:
            return "Maj"
        case 6:
            return "Czerwiec"
        case 7:
            return "Lipiec"
        case 8:
            return "Sierpień"
        case 9:
            return "Wrzesień"
        case 10:
            return "Październik"
        case 11:
            return "Listopad"
        case 12:
            return "Grudzień"
        default:
            return "Brak"

    }
}